<template>
  <div id="pc_content">
    <real-intention-preview-content
      :real-intention="realIntention"
    />
    <div class="space-18px">
    &nbsp;
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/realintention/_base" as *;
</style>

<script>
import RealIntentionPreviewContent from '@/components/organisms/RealIntentionPreviewContent'

export default {
  components: {
    RealIntentionPreviewContent
  },
  data () {
    return {
      realIntention: {}
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.$http.secured.get(`/real_intention/real_intentions/${this.$route.params.id}`).then(response => {
        this.$set(this, 'realIntention', response.data)
      })
    }
  }
}
</script>
